import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { RemoveSidenavlistService } from '../../services/remove-sidenavlist.service';
import { Subscription } from 'rxjs';
import { PAYMENTATTEMPT_STATUS } from 'src/app/shared/paymentStatuses';
import { CardPaymentsCallbacksService } from './card-payments-callbacks.service';

declare let $: any;

@Component({
  selector: 'app-card-payments-callbacks',
  templateUrl: './card-payments-callbacks.component.html',
  styleUrls: ['./card-payments-callbacks.component.scss'],
})
export class CardPaymentsCallbacksComponent implements OnInit, OnDestroy {
  amount: number;
  status: string = '';
  providerRef: string;
  paymentPaid: boolean = true;
  subscription: Subscription;
  isCreditCard: boolean = false;
  gateMessage: string;
  showRecipt: boolean = false;
  showPleaseWait: boolean = true;
  refNum: string;
  customerRedirectUrl: URL;
  customerRef: string;
  reason: string = '';

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public translate: TranslateService,
    private removeSidenavService: RemoveSidenavlistService,
    private cardPaymentsCallbacksService: CardPaymentsCallbacksService,
    @Inject(PLATFORM_ID) private platformID: any
  ) {
    this.translate.use('en');
  }

  async ngOnInit() {
    if (isPlatformBrowser(this.platformID)) {
      this.subscription = this.route.queryParams.subscribe(async (data) => {
        this.status = data.status;
        this.gateMessage = data.status;
        this.refNum = data.refNum;
        this.isCreditCard = true;
        this.cardPaymentsCallbacksService.setParams({
          status: this.status,
          refNum: this.refNum,
          resultIndicator: data.resultIndicator,
        });
        const result = await this.cardPaymentsCallbacksService.make();
        if (result.status === PAYMENTATTEMPT_STATUS.PAID) {
          this.paymentPaid = true;
          this.showPleaseWait = false;
        } else {
          this.paymentPaid = false;
          this.showPleaseWait = false;
        }
      });

      $(document).ready(function () {
        let whe = $(window).height();
        let hehe = $('.header').height();
        let fohe = $('.ekfe-footer').height();
        $('.main').css('min-height', whe - hehe - fohe - 50 - 36 - 120);
      });

      $(window).resize(function () {
        let whe = $(window).height();
        let hehe = $('.header').height();
        let fohe = $('.ekfe-footer').height();
        $('.main').css('min-height', whe - hehe - fohe - 50 - 36 - 120);
      });

      $('.bur-button').on('click', function () {
        $('.header-login-hide').slideToggle(500);
      });

      $(document).ready(function () {
        let p = $('.image-block').height();
        $('.business-over').css('top', p);
      });

      $(window).resize(function () {
        let p = $('.image-block').height();
        $('.business-over').css('top', p);
      });
    }
  }

  onContinueClick() {
    this.router.navigate(['/']);
  }

  ngOnDestroy() {
    this.removeSidenavService.emitSidenavO(true);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
